import React, { useEffect, useRef, useState } from "react";

import DualListBox from "react-dual-listbox";
import { Button, Card, Col, message, Row, Space } from "antd";

import { get } from "services/bot.service";
import { LeftOutlined, RightOutlined } from "@ant-design/icons";
import { getMappingBotInfo, mappingUser } from "services/platform.service";

import styles from "./styles.module.scss";

import "react-dual-listbox/lib/react-dual-listbox.css";

type PlatformBotMappingType = {
  platformCode: string;
};

const PlatformBotMapping: React.FC<PlatformBotMappingType> = (props) => {
  const { platformCode } = props;
  const [selectedBot, setSelectedBot] = useState([]);
  const initSelectedBot = useRef([]);
  const [options, setOptions] = useState<
    { value: string; label: string }[] | []
  >([]);

  const initOption = async () => {
    const bots = await get({});
    bots.forEach((bot) => {
      const val = {
        value: bot.code,
        label: bot.name,
      };
      setOptions((options) => {
        const newOptions = [...options];
        newOptions.push(val);
        return newOptions;
      });
    });
  };

  const callMapping = async () => {
    await mappingUser(platformCode, selectedBot);
    message.success("Save successfully");
  };

  const callInitMappingBotInfo = async (platformCode: string) => {
    if (!platformCode) {
      return;
    }
    const codeBots = await getMappingBotInfo(platformCode);
    setSelectedBot(codeBots);
    initSelectedBot.current = codeBots;
  };

  const resetSelectedBotAsInit = () => {
    setSelectedBot(initSelectedBot.current);
  };

  useEffect(() => {
    initOption();
    callInitMappingBotInfo(platformCode);
  }, [platformCode]);

  return (
    <>
      <div className="layout-content">
        <Row className="rowgap-vbox" gutter={[24, 0]}>
          <Col xs={24} sm={24} md={24} lg={24} xl={24} className="mb-24">
            <Card bordered={false}>
              <DualListBox
                className={styles.mapping}
                canFilter
                options={options}
                selected={selectedBot}
                onChange={(value: any) => setSelectedBot(value)}
                icons={{
                  moveRight: <RightOutlined />,
                  moveLeft: <LeftOutlined />,
                  moveAllLeft: <></>,
                  moveAllRight: <></>,
                }}
              />
              <div className={styles.saveSection}>
                <Space>
                  <Button type="primary" onClick={callMapping}>
                    Save
                  </Button>
                  <Button onClick={resetSelectedBotAsInit}>Reset</Button>
                </Space>
              </div>
            </Card>
          </Col>
        </Row>
      </div>
    </>
  );
};

export default PlatformBotMapping;
